import React, { Component } from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { SearchBar } from '../../SearchBar';

import { StopsCommand } from '../commands/StopsCommand';
import { StopsDraftCommand } from '../commands/StopsDraftCommand';
import { HandleMessage } from '../../HandleMessage';
import { StopActiveForm } from './StopActiveForm';
import { StopDraftForm } from './StopDraftForm';
import { HandleDialog } from '../../HandleDialog';
import { LoadingSpinner } from '../../LoadingSpinner';
import { StopsMap } from './StopsMap';

export class StopsMapViewer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            stops: props.stops,
            form: {
                stop: undefined,
                active: {
                    stopsCreated: [],
                    stopsEdited: [],
                    stopsDeleted: [],
                    type: "create",
                    obj: undefined,
                    original: undefined,
                    title: "",
                    codeInputError: null,
                    nameInputError: null,
                    latitudeInputError: null,
                    longitudeInputError: null
                },
                draft: {
                    stopsCreated: [],
                    stopsEdited: [],
                    stopsDeleted: [],
                    type: "create",
                    obj: undefined,
                    original: undefined,
                    title: "",
                    codeInputError: null,
                    nameInputError: null,
                    latitudeInputError: null,
                    longitudeInputError: null
                },
                newId: -1
            },
            render: {
                showSaveButton: false,
                showDeleteButton: false,
                filter: "",
            },
            actions: {
                active: {
                    isCreating: false,
                    isUpdating: false,
                    isDeleting: false,
                },
                draft: {
                    isCreating: false,
                    isUpdating: false,
                    isDeleting: false,
                }
            },
            commands: {
                active: {
                    stops: new StopsCommand(),
                },
                draft: {
                    stops: new StopsDraftCommand(),
                }
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            },

            showActiveNetwork: true,
        }
    }

    // ------------------------------

    operationSuccessCallback(result, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            result.message = `${message.message}\n${result.message}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: result.message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof (callback)) {
            callback(result.data);
        }
    }

    operationErrorCallback(messageReceived, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });

        if ("function" === typeof (callback)) {
            callback();
        }
    }

    // ------------------------------

    handleEditionSwitch() {
        this.setState({
            showActiveNetwork: !this.state.showActiveNetwork,
        });
    }

    hasPendingChanges() {
        const { form } = this.state;

        return (
            form.active.stopsCreated.length > 0 ||
            form.active.stopsEdited.length > 0 ||
            form.active.stopsDeleted.length > 0 ||
            form.draft.stopsCreated.length > 0 ||
            form.draft.stopsEdited.length > 0 ||
            form.draft.stopsDeleted.length > 0
        );
    }

    onSaveChangesClick() {
        const { form, commands, actions } = this.state;
        const { edition } = this.props;
        
        const callback = () => this.onExitAfterSave();

        if (0 < form.active.stopsCreated.length) {
            actions.active.isCreating = true;
            commands.active.stops.saveBulk(
                edition,
                form.active.stopsCreated,
                (a) => this.operationSuccessCallback(a, "isCreating", "active", callback),
                (a) => this.operationErrorCallback(a, "isCreating", "active", callback)
            );
        }

        if (0 < form.active.stopsEdited.length) {
            actions.active.isUpdating = true;
            commands.active.stops.editBulk(
                edition,
                form.active.stopsEdited,
                (a) => this.operationSuccessCallback(a, "isUpdating", "active", callback),
                (a) => this.operationErrorCallback(a, "isUpdating", "active", callback)
            );
        }

        if (0 < form.active.stopsDeleted.length) {
            actions.active.isDeleting = true;
            commands.active.stops.deleteBulk(
                edition,
                form.active.stopsDeleted,
                (a) => this.operationSuccessCallback(a, "isDeleting", "active", callback),
                (a) => this.operationErrorCallback(a, "isDeleting", "active", callback)
            );
        }

        if (0 < form.draft.stopsCreated.length) {
            actions.draft.isCreating = true;
            commands.draft.stops.saveBulk(
                edition,
                form.draft.stopsCreated,
                (a) => this.operationSuccessCallback(a, "isCreating", "draft", callback),
                (a) => this.operationErrorCallback(a, "isCreating", "draft", callback)
            );
        }

        if (0 < form.draft.stopsEdited.length) {
            actions.draft.isUpdating = true;
            commands.draft.stops.editBulk(
                edition,
                form.draft.stopsEdited,
                (a) => this.operationSuccessCallback(a, "isUpdating", "draft", callback),
                (a) => this.operationErrorCallback(a, "isUpdating", "draft", callback)
            );
        }

        if (0 < form.draft.stopsDeleted.length) {
            actions.draft.isDeleting = true;
            commands.draft.stops.deleteBulk(
                edition,
                form.draft.stopsDeleted,
                (a) => this.operationSuccessCallback(a, "isDeleting", "draft", callback),
                (a) => this.operationErrorCallback(a, "isDeleting", "draft", callback)
            );
        }

        this.setState({
            actions: actions
        });
    }

    onDragend(dataType, stopId, e) {
        const { stops, form, render } = this.state;

        let parentStops = undefined;
        let stopsEdited = [];
        let stopsCreated = [];

        switch (dataType) {
            case "active":
                parentStops = stops.active;
                stopsCreated = form.active.stopsCreated;
                stopsEdited = form.active.stopsEdited;
                break;

            case "draft":
                parentStops = stops.draft;
                stopsCreated = form.draft.stopsCreated;
                stopsEdited = form.draft.stopsEdited;
                break;

            default:
                break;
        }

        if (undefined === parentStops) {
            return;
        }

        if (stopId !== 0) {
            let create = 0;
            let pos = -1;
            let stop = parentStops.find(s => s.id === stopId);

            if (stopsEdited.length > 0) {
                stopsEdited.forEach((stop, i) => {
                    if (stop.id !== stopId) {
                        create++;
                    } else {
                        pos = i;
                    }
                });
            }

            stop.latitude = e.target._latlng.lat;
            stop.longitude = e.target._latlng.lng;
            stop.position[0] = e.target._latlng.lat;
            stop.position[1] = e.target._latlng.lng;

            if (create === stopsEdited.length) {
                if (undefined === stopsCreated.find(s => s === stop)) {
                    stopsEdited.push(stop);
                }
            } else {
                stopsEdited[pos] = stop;
            }

            render.showSaveButton = true;

            this.setState({
                form: form,
                render: render
            });
        } else {
            this.setState({
                alertTitle: "Aviso",
                alertMessage: "Paragem Inválida",
                alertStyle: "warning",
                icon: 'alert',
                showErrorModal: true
            });
        }
    }

    onChangeValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].obj[value] = e.target.value;

        this.setState({
            form: form,
        });
    }

    onSelectValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].obj[value] = e;

        this.setState({
            form: form,
        });
    }

    onCheckValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].obj[value] = e.target.checked;

        this.setState({
            form: form,
        });
    }

    onClickCreateStop(dataType, e) {
        const { form } = this.state;

        let stopId = Math.random() * form.newId;

        form.newId = form.newId--;
        form[dataType].type = "create";
        form[dataType].title = "Criar";
        form[dataType].original = undefined;
        form[dataType].obj = {
            code: "",
            extCode: "",
            shortName: "",
            position: [
                e.latlng.lat,
                e.latlng.lng
            ],
            hidden: false,
            id: stopId,
            isActive: false,
            name: "",
            latitude: e.latlng.lat,
            longitude: e.latlng.lng
        };

        this.setState({
            form: form
        });
    }

    onClickEditStop(dataType, stopId) {
        const { stops } = this.props;
        const { form, render } = this.state;

        if (undefined !== stops) {
            const stop = stops[dataType].find(s => s.id === stopId);

            form[dataType].type = "edit";
            form[dataType].title = "Editar";
            form[dataType].original = stop;
            form[dataType].obj = Object.assign({
                code: "",
                extCode: "",
                shortName: "",
                position: [0, 0],
                hidden: false,
                id: stopId,
                isActive: false,
                name: "",
                latitude: 0,
                longitude: 0
            }, stop);

            render.showDeleteButton = true;

            this.setState({
                form: form,
                render: render
            });
        }
    }

    onExit() {
        if (this.hasPendingChanges()) {
            this.setState({
                dialog: {
                    show: true,
                    title: "Aviso",
                    message: "Se sair vai perder todas alterações feitas. Tem a certeza que quer sair?",
                    icon: "alert",
                    style: "warning",
                    argument: {
                        isToExit: true,
                        isToCancel: false,
                        dataType: "all"
                    }
                }
            });

            return;
        }

        this.props.onHide(false);
    }

    onExitAfterSave() {
        const { actions } = this.state;

        if(actions.active.isCreating || actions.active.isUpdating || actions.active.isDeleting || actions.draft.isCreating || actions.draft.isUpdating || actions.draft.isDeleting) {
            return;
        }

        const { form, message } = this.state;

        form.active.stopsCreated = [];
        form.active.stopsEdited = [];
        form.active.stopsDeleted = [];
        form.draft.stopsCreated = [];
        form.draft.stopsEdited = [];
        form.draft.stopsDeleted = [];
        
        this.props.onHide(true, message);
        this.setState({
            form: form,
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        });
    }

    onStopFormExit(dataType) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: "Se cancelar vai perder todas alterações feitas. Tem a certeza que quer cancelar?",
                icon: "alert",
                style: "warning",
                argument: {
                    isToExit: true,
                    isToCancel: true,
                    dataType: dataType
                }
            }
        });
    }

    onSaveStop(dataType) {
        if (this.isValidInput(dataType)) {
            const { stops, form, render } = this.state;

            const parentStops = stops[dataType];
            const stopsCreated = form[dataType].stopsCreated;
            const stopsEdited = form[dataType].stopsEdited;

            if (form[dataType].obj.id < 0) {
                let index = stopsCreated.indexOf(form[dataType].original);
                if (-1 === index) {
                    stopsCreated.push(form[dataType].obj);
                }
                else {
                    stopsCreated[index] = form[dataType].obj;
                }
            } else {
                let index = stopsEdited.indexOf(form[dataType].original);

                if (index > 0) {
                    stopsEdited[index] = form[dataType].obj;
                } else {
                    stopsEdited.push(form[dataType].obj);
                }
            }

            const existingStop = parentStops.find(stop => stop.id === form[dataType].obj.id);

            const index = parentStops.indexOf(existingStop);
            if (index !== -1) {
                parentStops.splice(index, 1);
            }
            parentStops.push(form[dataType].obj);

            form[dataType].obj = undefined;
            form[dataType].original = undefined;
            render.showSaveButton = true;

            this.setState({
                stops: stops,
                form: form,
                render: render
            });
        }
    }

    onDeleteStop(dataType) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: "Tem a certeza que pretende eliminar a paragem?",
                icon: "alert",
                style: "warning",
                argument: {
                    isToExit: false,
                    isToCancel: false,
                    dataType: dataType
                }
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { form, render } = this.state;

            if (argument.isToExit) {
                if (argument.isToCancel) {
                    form.active.obj = undefined;
                    form.active.original = undefined;
                    form.draft.obj = undefined;
                    form.draft.original = undefined;

                    render.showSaveButton = this.hasPendingChanges();
                }
                else {
                    form.active.stopsCreated = [];
                    form.active.stopsEdited = [];
                    form.active.stopsDeleted = [];
                    form.draft.stopsCreated = [];
                    form.draft.stopsEdited = [];
                    form.draft.stopsDeleted = [];

                    render.showSaveButton = false;

                    this.props.onHide(false);
                }
            }
            else {
                const { stops } = this.props;

                let parentStops;
                let stop;
                switch (argument.dataType) {
                    case "active":
                        parentStops = stops.active;
                        stop = form.active.original;
                        break;

                    case "draft":
                        parentStops = stops.draft;
                        stop = form.draft.original;
                        break;

                    default:
                        break;
                }

                if (undefined === stops) {
                    return;
                }

                let stopsCreated = form[argument.dataType].stopsCreated;
                let stopsEdited = form[argument.dataType].stopsEdited;
                let stopsDeleted = form[argument.dataType].stopsDeleted;

                const indexInStops = parentStops.indexOf(stop);
                const indexInStopsC = stopsCreated.indexOf(stop);
                const indexInStopsE = stopsEdited.indexOf(stop);

                if (indexInStops !== -1) {
                    parentStops.splice(indexInStops, 1);

                    if (indexInStopsC !== -1) {
                        stopsCreated.splice(indexInStopsC, 1);
                    }

                    if (indexInStopsE !== -1) {
                        stopsEdited.splice(indexInStopsE, 1);
                    }

                    stopsDeleted.push(stop);
                    form.active.obj = undefined;
                    form.active.original = undefined;
                    form.draft.obj = undefined;
                    form.draft.original = undefined;

                    this.setState({
                        stops: stops
                    });
                }
            }

            render.showDeleteButton = false;

            this.setState({
                form: form
            }, () => {
                render.showSaveButton = this.hasPendingChanges();

                this.setState({
                    render: render
                });
            });
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    onUpdateFilter(e) {
        const { render } = this.state;

        render.filter = e.flatMap(f => f.value).join('|');

        this.setState({
            render: render
        });
    }

    onSearch(filter) {
        const { render } = this.state;

        render.filter = filter;

        this.setState({
            render: render
        });
    }

    // ----------------------

    isValidInput(dataType) {
        const { form } = this.state;
        let errors = 0;

        form[dataType].codeInputError = null;
        form[dataType].nameInputError = null;
        form[dataType].latitudeInputError = null;
        form[dataType].longitudeInputError = null;

        if (undefined === form[dataType].obj.code || null === form[dataType].obj.code || "" === form[dataType].obj.code) {
            form[dataType].codeInputError = 'error';
            errors++;
        }

        if (undefined === form[dataType].obj.name || null === form[dataType].obj.name || "" === form[dataType].obj.name) {
            form[dataType].nameInputError = 'error';
            errors++;
        }

        if (undefined === form[dataType].obj.latitude || null === form[dataType].obj.latitude || "" === form[dataType].obj.latitude || isNaN(form[dataType].obj.latitude)) {
            form[dataType].latitudeInputError = 'error';
            errors++;
        }

        if (undefined === form[dataType].obj.longitude || null === form[dataType].obj.longitude || "" === form[dataType].obj.longitude || isNaN(form[dataType].obj.longitude)) {
            form[dataType].longitudeInputError = 'error';
            errors++;
        }

        this.setState({
            form: form
        });

        return 0 === errors;
    }

    // --------------------------

    renderActiveForm() {
        const { form, render } = this.state;

        if (undefined === form.active.obj) {
            return null;
        }

        return (
            <StopActiveForm show={true}
                form={form.active}
                showDeleteButton={render.showDeleteButton}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "active")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "active")}
                onCheckValue={(a, b) => this.onCheckValue(a, b, "active")}
                onSave={() => this.onSaveStop("active")}
                onDelete={() => this.onDeleteStop("active")}
                onHide={() => this.onStopFormExit("active")} />
        );
    }

    renderDraftForm() {
        const { form, render } = this.state;

        if (undefined === form.draft.obj) {
            return null;
        }

        return (
            <StopDraftForm show={true}
                form={form.draft}
                showDeleteButton={render.showDeleteButton}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "draft")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "draft")}
                onCheckValue={(a, b) => this.onCheckValue(a, b, "draft")}
                onSave={() => this.onSaveStop("draft")}
                onDelete={() => this.onDeleteStop("draft")}
                onHide={() => this.onStopFormExit("draft")} />
        );
    }

    renderOperationFeedback(text, isExecuting) {
        return (
            <HandleMessage
                title={text}
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isExecuting}
                small
                noButtons />
        );
    }

    render() {
        const { stops } = this.state;

        if (!stops.show) {
            return null;
        }

        const { render, actions, dialog } = this.state;

        return (
            <div>
                <Modal show={true} className="map-modal">
                    <Modal.Header>
                        <Modal.Title>Paragens no Mapa</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Row>
                            <Col md={12} className="mb-4 d-flex align-items-center">
                                <span
                                    className={`stops-map-viewer-btn ${this.state.showActiveNetwork ? 'selected' : 'unselected'}`}
                                    onClick={() => this.setState({ showActiveNetwork: true })}
                                >
                                    Rede Ativa
                                </span>
                                <span
                                    className={`stops-map-viewer-btn ${!this.state.showActiveNetwork ? 'selected' : 'unselected'}`}
                                    onClick={() => this.setState({ showActiveNetwork: false })}
                                >
                                    Rascunho
                                </span>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <div className="search-bar margin-bottom-10">
                                    <SearchBar onSearch={(a) => this.onSearch(a)} />
                                </div>

                                <StopsMap
                                    stops={this.state.showActiveNetwork ? stops.active : stops.draft}
                                    filter={render.filter}
                                    onDragend={(a, b) => this.onDragend(this.state.showActiveNetwork ? "active" : "draft", a, b)}
                                    onClickEditStop={(a) => this.onClickEditStop(this.state.showActiveNetwork ? "active" : "draft", a)}
                                    onClickCreateStop={(a) => this.onClickCreateStop(this.state.showActiveNetwork ? "active" : "draft", a)}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <div className="stopsMapButtonsFooter">
                                    {render.showSaveButton && (
                                        <Button className="saveChangesButton" onClick={() => this.onSaveChangesClick()}>
                                            GUARDAR ALTERAÇÕES
                                        </Button>
                                    )}
                                    <Button className="closeButton" onClick={() => this.onExit()}>FECHAR</Button>
                                </div>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>

                {this.renderActiveForm()}
                {this.renderDraftForm()}

                {
                    this.renderOperationFeedback(
                        "A Executar...",
                        actions.active.isCreating || actions.active.isUpdating || actions.active.isDeleting || actions.draft.isCreating|| actions.draft.isUpdating || actions.draft.isDeleting
                    )
                }

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        )
    }
}
